import axios from 'axios';
import moment from 'moment';
import { isEmpty } from 'underscore';
import { DT0Format } from '../generic/StaticVariable';
import { PostShoppingItem, ShoppingResult } from '../typings/shopping';
import { axiosInstance } from './Api';

export default class ShoppingCart {
  endpoint = 'ShoppingCart';

  async GetShoppingCart(checkStatus = false, withPrice = false): Promise<ShoppingResult> {
    const queryParams = new URLSearchParams();
    queryParams.append('checkExtractionStatus', checkStatus.toString());
    queryParams.append('withPrice', withPrice.toString());

    const data = {
      shoppingItems: {},
    };

    try {
      const r = await axiosInstance.get(
        `/${this.endpoint}/GetShoppingCart_v2?${queryParams.toString()}`
      );
      if (r.data.Error || isEmpty(r.data.Result)) {
        return data as any;
      }
      return r.data.Result;
    } catch (error) {
      return data as any;
    }
  }

  async AddShoppingCartItem_v2(params: PostShoppingItem) {
    const current = moment();
    const connectionString = {
      ...params,
      datasetName: params.datasetId,
      fileFormat: 'csv',
      requestedTime: current.format(DT0Format),
      verticalLevel: null,
      location: params.coords.join(', '),
    };
    const payload = {
      analytics: [],
      extractionResultData: { datasetPrice: params.price },
      connectionString: connectionString,
    };
    try {
      const r: any = await axiosInstance.post(
        `/${this.endpoint}/AddShoppingCartItem_v2`,
        payload);

      return r.data;
    } catch (error) {
      return { Result: null, Error: error };
    }
  }

  async DeleteShoppingItem(orderId: string) {
    const r = await axiosInstance.delete(
      `/${this.endpoint}/DeleteShoppingItemByOrderIdV2`,
      {
        params: {
          orderId: orderId,
        },
      }
    );
    return r.data;
  }

  // Batch delete shopping items
  async DeleteShoppingItems(orderIds: string[]) {
    const requests = orderIds.map((orderId) =>
      axiosInstance
        .delete(
          `/${this.endpoint}/DeleteShoppingItemByOrderIdV2?datasetId=${orderId}`
        )
        .catch((_err) => null)
    );
    const responses = await axios.all(requests);
    return responses.map((response) => {
      return { ...response?.data };
    });
  }
}
